import { ColumnInstance, FilterValue, Hooks, UseFiltersColumnProps } from "react-table";

export const filterDisplayHook = (hooks: Hooks<any>) => {
  hooks.visibleColumns.push((columns) => 
    columns.map((column) => {

      const colInstance = column as ColumnInstance<any> & UseFiltersColumnProps<any>;

      colInstance.setCustomFilter = (filterValue: FilterValue) => {
        colInstance.filterDisplayValue = filterValue.name;

        colInstance.setFilter(filterValue.value);
      }

      return colInstance;
    }));

  }